import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, OnDestroy {

  alertStatus = 'hide';
  message: string;
  header: string;
  subscription: any = [];

  constructor(private alert: AlertService) { }

  ngOnInit(): void {
    const showAlertMessageSub1 = this.alert.showAlertStatus.subscribe(status => this.alertStatus = status);
    this.subscription.push(showAlertMessageSub1);
    const showAlertMessageSub2 = this.alert.showAlertMessage.subscribe(message => this.message = message);
    this.subscription.push(showAlertMessageSub2);
    const headerMessage = this.alert.headerMessage.subscribe(header => {
      this.header = header || "Alert";
    });
    this.subscription.push(headerMessage);
  }

  closeAlert(): void {
    this.alert.hide();
  }
  ngOnDestroy(): void {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
  }

}
